<template>
    <div class="news-wrapper container-fluid" id="news">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 content-left-aligned">
                    <h2>News</h2>
                    <p>
                        Currently we are locked away in a room, working hard to figure out some great mechanics to
                        bring those stories to your favourite game platform. We are paper prototyping, reading, fact
                        checking, reading more, retracing steps and interviewing other professional game developers
                        who have experience with translating a true story into a game experience (podcast coming
                        up!). Drop your mail address in the bar below and we will make sure to keep you up to date
                        with the latest news.
                    </p>
                </div>
            </div>

            <div>
                <!-- Begin MailChimp Signup Form -->
                <div id="mc_embed_signup">
                    <form
                        action="https://sisterhoodgame.us19.list-manage.com/subscribe/post?u=9cf2b50e2f209095b5f856e0e&amp;id=81a16624ba"
                        method="post"
                        id="mc-embedded-subscribe-form"
                        name="mc-embedded-subscribe-form"
                        class="validate"
                        target="_blank"
                        novalidate
                    >
                        <div class="row signup">
                            <div
                                class="col-1 col-md-1 offset-md-2 content-left-aligned signup-icon"
                            >
                                <img :src="news" class="news-icon">
                            </div>

                            <div class="col-12 col-md-5 content-left-aligned signup-email">
                                <input
                                    type="email"
                                    value
                                    name="EMAIL"
                                    class="required email"
                                    id="mce-EMAIL"
                                    placeholder="Type your mail adress here..."
                                >
                            </div>

                            <div class="col-12 col-md-2 content-right-aligned signup-submit">
                                <div style="position: absolute; left: -5000px;" aria-hidden="true">
                                    <input
                                        type="text"
                                        name="b_9cf2b50e2f209095b5f856e0e_81a16624ba"
                                        tabindex="-1"
                                        value
                                    >
                                </div>
                                <input
                                    type="submit"
                                    value="Submit"
                                    name="subscribe"
                                    id="mc-embedded-subscribe"
                                    class="button"
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div id="mce-responses" class="clear">
                                <div class="response" id="mce-error-response" style="display:none"></div>
                                <div
                                    class="response"
                                    id="mce-success-response"
                                    style="display:none"
                                ></div>
                            </div>
                            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsIcon from "@/assets/img/news-icon.svg";

export default {
    name: "News",
    data() {
        return {
            news: NewsIcon
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";

.news-icon {
    height: 52px;
    width: auto;
}

.news-wrapper {
    padding: 60px 0;
    margin-bottom: 60px;
    background-image: url(../assets/img/news-bg.jpg);

    h2,
    p {
        color: $white;
    }
}

.signup {
    margin-top: 40px;
}
</style>
